import { getCountries as e, getCountryCallingCode as t, isSupportedCountry as n } from "react-phone-number-input/input-max";
import r from "libphonenumber-js/examples.mobile.json";
import { AsYouType as i, formatIncompletePhoneNumber as a, getExampleNumber as o, isPossiblePhoneNumber as s, isValidPhoneNumber as c, parsePhoneNumberFromString as l, validatePhoneNumberLength as u } from "libphonenumber-js/max";
import d from "libphonenumber-js/metadata.max.json";
//#region src/phone-input/phone-input-utils.ts
var f = { IC: {
	callingCode: "34",
	defaultName: "Canary Islands",
	formatCountry: "ES"
} }, p = e(), m = new Set(p);
function h(e) {
	return Object.prototype.hasOwnProperty.call(f, e);
}
function g(e) {
	return f[e];
}
function _(e) {
	return n(e) || h(e);
}
function v(e) {
	if (n(e)) return e;
	let t = g(e);
	if (t) return t.formatCountry;
	throw Error(`Unsupported phone country code: ${e}`);
}
function y(e) {
	return e?.startsWith("+") ? e : "";
}
function b(e) {
	return e.replace(/\D/g, "");
}
function x(e) {
	if (!e || e === "+" || !b(e)) return !0;
	let t = new i();
	return t.input(e.startsWith("+") ? e : `+${e}`), !t.getNumber()?.nationalNumber;
}
function S(e) {
	return !e?.startsWith("+") || x(e) ? "" : e;
}
function C(e) {
	return `+${O(e)}`;
}
function w(e) {
	let t = d.country_calling_codes[e];
	if (t?.length) {
		for (let e of t) if (_(e)) return e;
	}
}
function T(e, t) {
	let n = b(e);
	if (!n) return;
	let r = new i();
	r.input(e.startsWith("+") ? e : `+${e}`);
	let a = r.getCountry();
	if (a && _(a)) return a;
	let o = [...p, ...Object.keys(f)], s;
	for (let e of o) {
		let t = O(e);
		if (n.startsWith(t)) {
			(!s || t.length > s.dialCode.length || t.length === s.dialCode.length && !s.fullMatch) && (s = {
				country: e,
				dialCode: t,
				fullMatch: !0
			});
			continue;
		}
		!s?.fullMatch && t.startsWith(n) && (!s || t.length < s.dialCode.length) && (s = {
			country: e,
			dialCode: t,
			fullMatch: !1
		});
	}
	if (s) return s.fullMatch ? _(t) && O(t) === s.dialCode ? t : w(s.dialCode) ?? s.country : s.country;
}
function E(e) {
	if (e == null || e === "") return "";
	let t = String(e).replace(/\D/g, "");
	return t ? `+${t}` : "";
}
function D(e) {
	return e == null || e === "" ? "" : e.startsWith("+") ? e.slice(1).replace(/\D/g, "") : e.replace(/\D/g, "");
}
function O(e) {
	let n = g(e);
	return n ? n.callingCode : t(v(e));
}
function k(e) {
	let t = d.countries[v(e)]?.[5];
	return typeof t == "string" && t.length > 0 ? t : void 0;
}
function A(e, t) {
	if (!e) return "";
	let n = `+${O(t)}`;
	return e.startsWith(n) ? e.slice(n.length).replace(/\D/g, "") : l(e)?.nationalNumber ?? "";
}
function j(e, t) {
	if (!e) return !1;
	let n = `+${O(t)}`;
	if (!e.startsWith(n)) return !1;
	let r = e.slice(n.length).replace(/\D/g, ""), i = k(t);
	if (!i || !r.startsWith(i)) return !1;
	let a = l(e)?.nationalNumber;
	return a ? r === `${i}${a}` && r !== a : !1;
}
function M(e, t) {
	return e ? a(e, v(t)) : "";
}
function N(e, t) {
	if (!A(e, t)) return "empty";
	let n = O(t);
	if (!e.startsWith(`+${n}`)) return "invalid-country";
	if (j(e, t)) return "invalid-format";
	switch (u(e)) {
		case "TOO_SHORT": return "too-short";
		case "TOO_LONG": return "too-long";
		case "INVALID_COUNTRY": return "invalid-country";
		case "INVALID_LENGTH":
		case "NOT_A_NUMBER": return "invalid-format";
		default: return c(e) ? void 0 : "invalid-format";
	}
}
function P(e, t) {
	let n = N(e, t);
	return {
		country: t,
		displayValue: M(e, t),
		isEmpty: n === "empty",
		isPossible: e !== "" && s(e),
		isValid: n == null,
		reason: n
	};
}
function F(e, t, n) {
	let r = A(e, t);
	return r ? `+${O(n)}${r}` : "";
}
function I(e, t) {
	let n = e.trim();
	if (!n.startsWith("+")) return null;
	let r = l(n);
	if (!r?.number) return null;
	let i = y(r.number);
	if (r.country && m.has(r.country)) return {
		country: r.country,
		value: i
	};
	if (r.countryCallingCode === O(t)) return {
		country: t,
		value: i
	};
	let a = w(r.countryCallingCode);
	if (a) return {
		country: a,
		value: i
	};
	let o = T(n, t);
	return o && _(o) ? {
		country: o,
		value: i
	} : null;
}
function L(e) {
	let t = o(v(e), r);
	return t ? a(t.number, v(e)).replace(/\d/g, "0") : "";
}
function R(e, t) {
	let n = e?.of(t);
	if (n != null && n !== t) return n;
}
function z(e, n = {}) {
	let r = typeof Intl.DisplayNames == "function" ? new Intl.DisplayNames([e], { type: "region" }) : void 0, i = new Intl.Collator(e, { sensitivity: "base" }), a = p.map((e) => ({
		callingCode: t(e),
		code: e,
		name: n[e] ?? R(r, e) ?? e
	})), o = Object.entries(f).map(([e, t]) => ({
		callingCode: t.callingCode,
		code: e,
		isLegacyStub: !0,
		name: n[e] ?? R(r, e) ?? t.defaultName
	}));
	return [...a, ...o].sort((e, t) => i.compare(e.name, t.name));
}
function B() {
	return Object.entries(f).map(([e, t]) => ({
		callingCode: t.callingCode,
		code: e,
		formatCountry: t.formatCountry
	}));
}
//#endregion
export { F as changePhoneCountry, O as getCountryCallingCodeValue, C as getCountryDialCodePrefix, A as getNationalDigits, M as getPhoneDisplayValue, P as getPhoneInputChangeDetails, z as getPhoneInputCountryOptions, L as getPhoneInputPlaceholder, T as guessPhoneCountryFromPartialNumber, j as hasLeadingNationalTrunk, x as isDialCodeOnlyPhoneValue, _ as isKnownPhoneCountry, h as isLegacyStubCountry, B as listLegacyPhoneCountryStubs, v as resolveFormatCountry, I as resolveInternationalPhonePaste, E as toE164FromLegacyDigits, D as toLegacyDigitsFromE164, y as toPhoneInputValue, S as toPublicPhoneInputValue };
